(function () {
  if (!window.location.pathname.includes('/products/')) return;

  const productHandle = window.location.pathname.split('/products/')[1].split('/')[0].split('?')[0];

  if (!productHandle) return;

  let productData = null;

  async function fetchProductData() {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) return;
      productData = await response.json();
    } catch (e) {
      console.error('Failed to fetch product data', e);
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents).replace('.00', '');
    }
    const amount = (cents / 100).toLocaleString('en-IN');
    return `Rs. ${amount}`;
  }

  function getSelectedOptions(form) {
    const selectedOptions = [];
    const optionElements = form.querySelectorAll('.product-options [name^="option"]');

    const processedNames = new Set();

    optionElements.forEach(elem => {
      if (elem.type === 'radio') {
        if (elem.checked) {
          selectedOptions.push(elem.value);
        }
      } else if (elem.type === 'select-one') {
        selectedOptions.push(elem.value);
      }
    });

    return selectedOptions;
  }

  function updateVariant(form, variant) {
    try {
      if (!variant) return;

      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
      }

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      const comparePrice = form.querySelector('.product-price-compare');
      const finalPrice = form.querySelector('.product-price-final');
      const saleBadge = form.querySelector('.product-sale-badge');
      const soldOutBadge = form.querySelector('.product-sold-out-badge');

      if (variant.compare_at_price > variant.price) {
        if (comparePrice) {
          comparePrice.textContent = formatMoney(variant.compare_at_price);
          comparePrice.removeAttribute('hidden');
        }
        if (finalPrice) {
          finalPrice.innerHTML = `<span class="visually-hidden">Sale price</span>${formatMoney(variant.price)}`;
          finalPrice.classList.add('product-price-final-sale');
        }
        if (saleBadge) {
          saleBadge.removeAttribute('hidden');
          const discountType = saleBadge.dataset.discountType;
          if (discountType === 'percentage') {
            const savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
            saleBadge.textContent = `Save ${savings}`;
          } else {
            const savings = formatMoney(variant.compare_at_price - variant.price);
            saleBadge.textContent = `Save ${savings}`;
          }
        }
      } else {
        if (comparePrice) {
          comparePrice.textContent = '';
          comparePrice.setAttribute('hidden', 'hidden');
        }
        if (finalPrice) {
          finalPrice.innerHTML = formatMoney(variant.price);
          finalPrice.classList.remove('product-price-final-sale');
        }
        if (saleBadge) {
          saleBadge.textContent = '';
          saleBadge.setAttribute('hidden', 'hidden');
        }
      }

      if (variant.available) {
        if (soldOutBadge) soldOutBadge.setAttribute('hidden', 'hidden');
      } else {
        if (soldOutBadge) soldOutBadge.removeAttribute('hidden');
      }

      const atcBtn = form.querySelector('.btn-atc');
      if (atcBtn) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.innerHTML = window.theme?.locales?.product?.add_to_cart || 'Add to cart';
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          atcBtn.innerHTML = window.theme?.locales?.product?.sold_out || 'Sold out';
        }
      }

      if (variant.featured_image && variant.featured_image.src) {
        const swiperMain = document.querySelector('.swiper-main');
        if (swiperMain && swiperMain.swiper) {
          const slideIndex = variant.featured_image.position - 1;
          if (slideIndex >= 0) {
            swiperMain.swiper.slideTo(slideIndex);
          }
        } else {
          const mainImage = document.querySelector('.product-card-img-wrapper img');
          if (mainImage) {
            mainImage.src = variant.featured_image.src;
          }
        }
      }

      window.dispatchEvent(new CustomEvent('kt.product.variant.change', {
        detail: variant
      }));

    } catch (e) {
      console.error('Error updating variant details', e);
    }
  }

  function handleOptionChange(event) {
    try {
      if (!productData) return;

      const form = event.target.closest('form');
      if (!form) return;

      const selectedOptions = getSelectedOptions(form);

      const variant = productData.variants.find(v => {
        return v.options.every((opt, index) => opt === selectedOptions[index]);
      });

      if (variant) {
        updateVariant(form, variant);
      }
    } catch (e) {
      console.error('Error handling option change', e);
    }
  }

  function init() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const options = form.querySelectorAll('.product-options [name^="option"]');
      options.forEach(option => {
        option.addEventListener('change', handleOptionChange);
      });
    });
  }

  fetchProductData().then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });

})();